import type { ReactNode } from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';

/** The design's answer paragraph (v2: 14px / 1.55, navy). Shared so string and markdown paragraphs match. */
export const ANSWER_PARAGRAPH_CLASS = 'm-0 text-sm leading-[1.55] text-dvaNavy';

const MD_COMPONENTS: Components = {
  p: ({ children }) => <p className={ANSWER_PARAGRAPH_CLASS}>{children}</p>,
  strong: ({ children }) => <strong className="font-bold">{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="border-b border-dvaNavy font-semibold text-dvaNavy no-underline hover:border-dvaOrange"
    >
      {children}
    </a>
  ),
  ul: ({ children }) => <ul className={`${ANSWER_PARAGRAPH_CLASS} flex list-disc flex-col gap-1 pl-5`}>{children}</ul>,
  ol: ({ children }) => <ol className={`${ANSWER_PARAGRAPH_CLASS} flex list-decimal flex-col gap-1 pl-5`}>{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  code: ({ children }) => <code className="rounded bg-dvaNavy/[0.06] px-1 text-[13px]">{children}</code>,
};

export function splitAnswerBlocks(markdown: string): string[] {
  return markdown
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean);
}

/** `answer_md` → one rendered node per blank-line-separated block. Raw HTML is never rendered. */
export function renderAnswerBlocks(markdown: string): ReactNode[] {
  return splitAnswerBlocks(markdown).map((block, index) => (
    <ReactMarkdown key={index} components={MD_COMPONENTS} disallowedElements={['img', 'html']} unwrapDisallowed>
      {block}
    </ReactMarkdown>
  ));
}
